import type { PatientResponse } from '../../api/generated';

// The drawer stores a snapshot of the patient taken when the row was clicked.
// Saving an in-drawer edit refreshes the patients list in Redux, so prefer the
// fresh store entry over the snapshot; fall back to the snapshot for the
// add-patient placeholder, which has no store entry yet.
export const resolveDisplayedPatient = (
  selectedPatient: PatientResponse | null,
  patientsById: Record<string, PatientResponse>
): PatientResponse | null =>
  selectedPatient ? (patientsById[selectedPatient.id] ?? selectedPatient) : null;
